import React, {Component} from 'react';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import {Carousel} from "react-responsive-carousel";
import {computeSliderArrows, computeSliderCount, computeTotalSlides} from "./utils";

class TeamCarousel extends Component {
    render() {
        let listPresent = this.props.teamList && this.props.teamList.length > 0;
        if (listPresent) {
            return <TeamList
                teamList={this.props.teamList}
                onClick={(i) => this.props.onClick(i)}
            />;
        } else {
            return <EmptyList/>;
        }
    }
}

class TeamList extends Component {
    constructor(props) {
        super(props);
        this.handleWindowResize = this.handleWindowResize.bind(this);
        this.setTotalSlides = this.setTotalSlides.bind(this);
        this.setSliderCount = this.setSliderCount.bind(this);
        this.setShowArrows = this.setShowArrows.bind(this);
        this.state = {
            totalSlidesCount: this.computeTotalSlidesCount(),
            totalSlides: computeTotalSlides(this.props.teamList.length, 4),
            sliderCount: computeSliderCount(9 / 2),
            showArrows: computeSliderArrows(this.props.teamList.length, 4),
            selectedItem: 0
        };
    }

    componentWillUnmount() {
        window.clearTimeout(this.throttle);
        window.removeEventListener('resize', this.handleWindowResize, false);
    }

    componentDidMount() {
        window.addEventListener('resize', this.handleWindowResize, false);
    }

    computeTotalSlidesCount() {
        return this.props.teamList.length;
    }

    setTotalSlides() {
        let membersCount = this.computeTotalSlidesCount()
        const totalSlides = computeTotalSlides(membersCount, 4);
        if (this.state.totalSlides !== totalSlides) {
            this.setState({
                totalSlides: totalSlides
            });
        }
    }

    setSliderCount() {
        const sliderCount = computeSliderCount(9 / 2);
        if (this.state.sliderCount !== sliderCount) {
            this.setState({
                sliderCount: sliderCount
            });
        }
    }

    setShowArrows() {
        const showArrows = computeSliderArrows(this.props.teamList.length, 4);
        if (this.state.showArrows !== showArrows) {
            this.setState({
                showArrows: showArrows
            });
        }
    }

    handleWindowResize() {
        window.clearTimeout(this.throttle);
        this.throttle = window.setTimeout(this.setTotalSlides, 200);
        this.throttle = window.setTimeout(this.setSliderCount, 200);
        this.throttle = window.setTimeout(this.setShowArrows, 200);
    }

    handleClick = (event, index) => {
        //let index = parseInt(event.target.dataset.key)
        this.props.onClick(index)
    }

    handleSelectedItem = (e) => {
        const width = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);

        if (width < 992) {
            this.setState({selectedItem: e});
        } else if (e + 2.5 >= this.props.teamList.length) {
            this.setState({selectedItem: this.props.teamList.length - 1});
        } else if (e > 2.5 && e < 6.5) {
            this.setState({selectedItem: e});
        } else if (e < 2.5) {
            this.setState({selectedItem: 0});
        } else {
            this.setState({selectedItem: e});
        }
    }

    slidesCount() {
        const width = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);

        if (width < 992) {
            return 1;
        } else if (this.state.selectedItem === 0 || (this.state.selectedItem === this.props.teamList.length - 1)) {
            return 11 / 2;
        } else {
            return 4;
        }
    }

    render() {
        return (
            <>
                <Carousel
                    showThumbs={false}
                    onClickItem={false}
                    onSwipeEnd={false}
                    onSwipeStart={false}
                    onSwipeMove={false}
                    swipeable={false}
                    infiniteLoop={false}
                    centerMode={true}
                    selectedItem={this.state.selectedItem}
                    onChange={(e) => {
                        this.handleSelectedItem(e)
                    }}
                    showArrows={this.state.showArrows}
                    slidesCount={this.slidesCount()}
                    centerSlidePercentage={100 / this.state.totalSlides}
                >
                    {this.props.teamList.map((team, index) => (
                        <div
                            className="team-list__item"
                            key={index}
                            data-key={index}
                            onClick={i => this.handleClick(i, index)}
                        >
                            <img className="team-list__item__image"
                                 src={team.image.url}
                                 alt={team.first_name + ' is the ' + team.designation + ' at ' + document.title}
                            />
                            <div className='team-list__item__wrap'>
                                <h3 className="team-list__item__name">{team.first_name}</h3>
                                <h4 className="team-list__item__designation">{team.designation}</h4>
                            </div>
                        </div>
                    ))}
                </Carousel>
            </>
        );
    }
}

function EmptyList(props) {
    return <h1> No Members </h1>;
}

export default TeamCarousel;
        